import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from '@xing-com/button';
import { useLoginAppUrl } from '@xing-com/crate-xinglet';
import { addParams } from '@xing-com/xing-tracking';

export const LoginButton: React.FC = () => {
  const loginLink = useLoginAppUrl();
  const [loginButtonTo, setLoginButtonTo] = useState<string | undefined>(
    undefined
  );

  const trackingUrl =
    loginLink &&
    addParams(loginLink, {
      nwt_nav: 'sign_up_button',
      sc_o: 'navigation_sign_up_button',
    });

  useEffect(() => {
    setLoginButtonTo(trackingUrl);
  }, [trackingUrl]);

  return (
    <Button to={loginButtonTo} href={loginLink} variant="primary" size="small">
      <FormattedMessage id="MAINNAV_LOGIN" />
    </Button>
  );
};
